module.exports = __webpack_public_path__ + "img/smartfram.cd77d59c.svg";